// extracted by css-extract-rspack-plugin
export default {"item":"pagination_item__Pzb1U","ellipsis":"pagination_ellipsis__l0GFL"};